import { Component, inject, model, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-how-does-hld-insurance-define',
  standalone: false,
  templateUrl: './define-hld-insurance.component.html',
  styleUrl: '../../../assets/css/HighLimitsDialogs.css'
})
export class DefineHLDInsuranceComponent {
  readonly dialogRef = inject(MatDialogRef<DefineHLDInsuranceComponent>);

  constructor() {
  }

  close() {
    this.dialogRef.close(false);
  }
}
